import { IQueryTransformer } from '@proscom/prostore-react-router';

export const stringTransformer: IQueryTransformer<string | undefined> = {
  parse: (x) => (x ? String(x) : undefined),
  stringify: (x) => x
};
